var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "25 105 95 105 95 15 25 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45 55 50 55 50 50 45 50"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45 105 63 105 75 105 75 75 45 75"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    x2: 60,
    y1: 104.5,
    y2: 75.961
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70 55 75 55 75 50 70 50"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45 35 50 35 50 30 45 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70 35 75 35 75 30 70 30"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    x2: 105,
    y1: 105,
    y2: 105
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.facf5cc69f267ed8a7f6ddca5853a16d.svg";
export { ForwardRef as ReactComponent };